<template>
    <a-modal
        title="选择标签"
        :visible="visible"
        wrapClassName="tag_select"
        @ok="toCheck"
        @cancel="toCancel"
    >
        <div style="text-align: right; margin-bottom: -21px;position: relative; z-index: 10;">
            <router-link to="/tag"  class="base_font_size_14 base_font_color_ff5800">
                新增客户标签
            </router-link>
        </div>
        <a-space direction="vertical" size="large">
            <li v-for="item in dataList" :key="item.groupId">
                <p>{{ item.groupName }}</p>
                <a-space class="dir_left_wrap">
                    <a-checkable-tag
                        v-for="el in item.tag"
                        :key="el.tagId"
                        :checked="selectKeys.map((col) => col.tagId).includes(el.tagId)"
                        @change="(checked) => tagChange(el, checked)"
                        style="margin-bottom: 5px;"
                    >
                        {{ el.tagName }}
                    </a-checkable-tag>
                </a-space>
            </li>
        </a-space>
    </a-modal>
</template>

<script>
import api from '@/apis';
import _ from 'lodash';
export default {
    props: {
        selectKey: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            visible: false,
            dataList: [],
            selectKeys: []
        };
    },
    methods: {
        open() {
            this.init();
            this.selectKeys = [...this.selectKey];
            this.visible = true;
        },
        async init() {
            try {
                const res = await api.getTag();
                if (res.code !== 0) return;
                this.dataList = res.tagGroup;
            } catch (err) {
                console.log(err);
            }
        },
        toCheck() {
            this.$emit('change', this.selectKeys);
            this.toCancel();
        },
        toCancel() {
            this.visible = false;
            this.selectKeys = [];
        },
        tagChange(el, checked) {
            el.key = el.tagId;
            el.label = el.tagName;
            if (checked) {
                this.selectKeys.push(el);
            } else {
                this.selectKeys = _.differenceBy(this.selectKeys, [el], 'tagId');
            }
        }
    }
};
</script>

<style>
.tag_select .ant-tag {
    background-color: #f2f4f5;
}
.tag_select .ant-tag-checkable-checked {
    background-color: #ff5800;
}
</style>
